import React from 'react';
import {filterOptions} from "../../../_common/utils/options";
import {StyledFieldSelect} from "../../../_common/components/FieldSelect";
import {FormikProvider} from 'formik';
import {useCreatePriceQuoteGIContext} from '../../contexts/CreatePriceQuoteGIContext';
import FieldInput from '../../../_common/components/FieldInput';
import {floatValue, integerValue} from '../../../../../utils/format';
import {optionsVatType} from '../../../CustomerDetails/constants/options';
import {createDocumentGridSelectStyles} from '../../../_common/selectStyles/customSelectStyles';
import styles from './styles.module.scss';

const EditableRow = ({
                       fieldsSet,
                       values,
                       removeRow,
                       index
                     }) => {
  const {formik} = useCreatePriceQuoteGIContext();
  const {setFieldValue} = formik;

  return (
    <div className={styles.editableRowContainer}>
      <FormikProvider value={formik}>
        <div className={styles.commonDocsRowContainer}>
          <StyledFieldSelect
            fieldId={`rowsCommonDocs.${index}.vatType`}
            name={fieldsSet.vatType}
            value={values.rowsCommonDocs[index].vatType}
            options={optionsVatType}
            styles={createDocumentGridSelectStyles}
            onChange={({ value }) =>
              setFieldValue(
                `rowsCommonDocs.${index}.vatType`,
                filterOptions(value)(optionsVatType)[0]
              )
            }
            disabled={true}
          />
          <FieldInput
            fieldId={fieldsSet.description}
            disabled={true}
          />
          <FieldInput
            fieldId={fieldsSet.quantity}
            onChange={integerValue}
            disabled={true}
          />
          <FieldInput
            fieldId={fieldsSet.price}
            onChange={floatValue}
            disabled={true}
          />
        </div>
      </FormikProvider>
    </div>
  );
};

export default EditableRow;
